import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {RouterLink, RouterOutlet} from '@angular/router';
import {MatToolbarModule} from '@angular/material/toolbar';
import {NgClass, NgOptimizedImage} from '@angular/common';
import {ShowMessageComponent} from './modules/process-info/components/show-message/show-message.component';
import {SidenavBtnComponent} from './utils/components/sidenav-btn/sidenav-btn.component';
import {TourStepTemplateComponent} from 'ngx-ui-tour-md-menu';
import {MatDialog} from '@angular/material/dialog';
import {
  LlmModelSettingDialogComponent
} from './utils/components/llm-model-setting-dialog/llm-model-setting-dialog.component';
import {MatIcon} from '@angular/material/icon';
import {MatButtonModule, MatIconAnchor, MatIconButton} from '@angular/material/button';
import {DeviceIdService} from './utils/services/device-id.service';
import {GithubIssueDialogComponent} from './utils/components/github-issue-dialog/github-issue-dialog.component';
import {MatTooltip} from '@angular/material/tooltip';
import {NgcCookieConsentModule, NgcCookieConsentService} from 'ngx-cookieconsent';
import {Subscription} from 'rxjs';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {MatMenuModule} from '@angular/material/menu';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet,
    MatToolbarModule,
    NgOptimizedImage,
    ShowMessageComponent,
    SidenavBtnComponent,
    RouterLink,
    TourStepTemplateComponent,
    MatIcon,
    NgcCookieConsentModule,
    MatIconButton,
    MatButtonModule,
    MatTooltip,
    MatMenuModule,
    MatIconAnchor,
    NgClass],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly dialog: MatDialog = inject(MatDialog);
  private readonly breakpointObserver: BreakpointObserver = inject(BreakpointObserver);
  private readonly deviceIdService: DeviceIdService = inject(DeviceIdService);
  private readonly ccService: NgcCookieConsentService = inject(NgcCookieConsentService);

  private subscriptions: Subscription = new Subscription();
  private readonly COOKIE_CONSENT_KEY = 'cookieConsent';

  title = 'Academate';


  isSmallScreen = false;

  ngOnInit(): void {
    this.deviceIdService.getDeviceId();
    this.initializeCookieConsent();

    this.subscriptions.add(
      this.breakpointObserver.observe([Breakpoints.Handset])
        .subscribe(result => {
          this.isSmallScreen = result.matches;
        })
    )
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  openSetting(): void {
    this.dialog.open(LlmModelSettingDialogComponent, {
      autoFocus: false,
      height: '600px',
      width: '600px',
      maxWidth: '100vw'
    });
  }

  openBugReport(): void {
    this.dialog.open(GithubIssueDialogComponent);
  }

  private initializeCookieConsent(): void {
    // Check if user has already made a cookie choice
    const savedConsent = localStorage.getItem(this.COOKIE_CONSENT_KEY);

    if (!savedConsent) {
      // Subscribe to status change to save the choice
      this.subscriptions.add(
        this.ccService.statusChange$.subscribe(event => {
          localStorage.setItem(this.COOKIE_CONSENT_KEY, event.status);
        })
      );

      // Initialize only if no choice was made previously
      this.subscriptions.add(
        this.ccService.initialized$.subscribe(() => {
          console.log('Cookie consent initialized');
        })
      );
    } else {
      // If consent was already given, prevent popup from showing
      this.ccService.destroy();
    }
  }

}
